import React from "react";
import PropTypes from "prop-types";

function SchoolYearSelector({
  activeSchoolYearStartYear,
  options,
  onChange,
}) {
  return (
    <div className="manage-school-year-selector">
      <span className="manage-school-year-selector-label">Rok szkolny</span>
      <select
        id="activeSchoolYearStartYear"
        name="activeSchoolYearStartYear"
        aria-label="Rok szkolny"
        className="form-control form-control-sm manage-school-year-selector-input"
        value={activeSchoolYearStartYear}
        onChange={(event) => onChange(Number(event.target.value))}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
}

SchoolYearSelector.propTypes = {
  activeSchoolYearStartYear: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SchoolYearSelector;
